import ImageInput from '../_component_settings/inputs/ImageInput';
import SEOItemWrapper from './SEOItemWrapper';

export default function SEOImageUploader({ id, label, addonLabel, seo, value, ...props }) {
  return (
    <SEOItemWrapper id={id} label={label} addonLabel={addonLabel} seo={seo}>
      <div className="mb-2">
        <ImageInput id={id} value={value} showTitle={false} {...props} />
      </div>
    </SEOItemWrapper>
  );
}
